import { map } from 'lodash';

export default {
  reportAssessmentItems: state => map(state.reportMetrics, a => ({
    metric: a.metric?.metricTab?.name,
    name: a.metric?.name,
    totalRequests: a.totalRequests,
    totalResponses: a.totalResponses,
    totalSuccess: a.totalSuccess,
    when: a.metric?.when,
    who: a.metric?.who,
    progress: Math.round(a.totalResponses / a.totalRequests * 100, 0),
  })),
};
